import { Tag, TopicType } from '../../ontology.model';

export const numberTags: Tag[] = [
  {
    id: 'tag.num',
    name: 'Number',
    topic_type: TopicType.Foundational,
    color: '#10b981',
    icon: 'calculator',
  },
];
